// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"324":"scene","443":"about"}[chunkId] || chunkId) + "." + {"324":"35fdd9e2","403":"b6f0338e","443":"a78d7b11"}[chunkId] + ".js";
};